import React from 'react';
import Header from '../Header/Header';
import Hero from "../Hero/Hero"
import Footer from "../Footer/Footer"

const HeroPage = () => {
  return (
   <>
      <Header/>
          <Hero />
          <Footer/>
    
   </>
  )
}

export default HeroPage